exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".links-cnt[data-v-5537bd5f] {\n  flex: 1;\n  display: block;\n  width: 100%;\n  height: 22px;\n}\n.links-swiper-container[data-v-5537bd5f] {\n  position: relative;\n  z-index: 1;\n}\n.links-wrapper[data-v-5537bd5f] {\n  position: absolute;\n}", ""]);

// exports
